import { style } from "@material-ui/system";
import React from "react";
import { Component } from "react";
import styles from "./CSSFiles/MobileBottom.module.css";
import { Link } from "react-router-dom";

class MobileBottom extends Component {
  render() {
    return (
      <div className={styles.mobileBottom}>
        <div className={styles.bottom_container}>
          <img src="./Image/DashImage/homeIcon.svg" className={styles.mobile_image} />
          <div className={styles.image_name}>Home</div>
        </div>
        
        <Link to="/classes" className={styles.bottom_container}>
          <img src="./Image/DashImage/Chalkmate_MyClasses_gray.svg" className={styles.mobile_image} />
          <div className={styles.image_name}>My Classes</div>
        </Link>
        
        <div className={styles.bottom_container}>
          <img src="./Image/DashImage/add.svg" className={styles.mobile_image} />
        </div>
        
        <div className={styles.bottom_container}>
          <img src="./Image/DashImage/Chalkmate_Mymessage.svg" className={styles.mobile_image} />
          <div className={styles.image_name}>Messages</div>
        </div>
        
        <div className={styles.bottom_container}>
          <img src="./Image/DashImage/Chalkmate_Notification.svg" className={styles.mobile_image} />
          <div className={styles.image_name}>Notifications</div>
        </div>
      </div>
    );
  }
}

export default MobileBottom;
